import { render, staticRenderFns } from "./CharacteristicColumnAdd.vue?vue&type=template&id=5d704b68&scoped=true"
import script from "./CharacteristicColumnAdd.vue?vue&type=script&lang=js"
export * from "./CharacteristicColumnAdd.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicColumnAdd.vue?vue&type=style&index=0&id=5d704b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d704b68",
  null
  
)

export default component.exports